<div class="container">
    <app-header></app-header>
    <app-repayment-input></app-repayment-input>
    <app-footer></app-footer>
</div>

